import { render, staticRenderFns } from "./VaffArrayField.vue?vue&type=template&id=8da2236e&scoped=true&"
import script from "./VaffArrayField.vue?vue&type=script&lang=js&"
export * from "./VaffArrayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da2236e",
  null
  
)

export default component.exports